<template>
  <div class="loading flex flex-col items-center justify-center py-4">
    <v-progress-circular
      indeterminate
      color="red"
    ></v-progress-circular>
    <v-card-text class="text-center">Loading...</v-card-text>
  </div>
</template>

<script>
export default {
  name: "Loading",
}
</script>

<style>

</style>